import { useEffect } from 'react';
import usePathNavigate from '../lib/hook/usePathNavigate';

function NotFound() {
  const { pathNavigate, backNavigate } = usePathNavigate();
  useEffect(() => {
    pathNavigate('/');
  }, []);
  return <div>Not Found</div>;
}

export default NotFound;
